import { gql } from '@apollo/client';

export const CONFIG_ITEM_FRAGMENT = gql`
  fragment ConfigItem on ConfigItemType {
      __typename
      configItemId
      key
      description
      defaultValue
      configItemValue {
        configItemValueId
        flagValue
      }
   }
`;

export type GlobalConfigItems = {
  vm: {
    preventVolunteerReports?: boolean;
    preventVolunteerAddOthersInReports?: boolean;
    preventVolunteerAvailabilitySubmission?: boolean;
    allowUnavailabilityAndLeave?: boolean;
    seeRosteredDatesOnly?: boolean;
    assignedRosteringView?: boolean;
    allowRosterComments?: boolean;
    showCapacityStatus?: boolean;
    blockFullSessionAvailability?: boolean;
    applicationAvailabilityComplex?: boolean;
    allowVolunteerActivityCancellation?: boolean;
    allowBackupSessions?: boolean;
    preventOverlappingSessions?: boolean;
    requireTasksBeforeJoining?: boolean;
    hideReportAttendance?: boolean;
    prefillReportAttendance?: boolean;
    requireDateOfBirth?: boolean;
    enterpriseSubLockStructures?: boolean;
  };
  im: {};
};
